import React from 'react';
import { renderLayerDom } from '@/utils/render-kit';
import { ILayerProps } from '@/version-types';
import BrushImage from './brush-image';

export function renderDom(identity: string, layer: ILayerProps): Promise<() => void> {
    return new Promise((resolve) => {
        const removeDomHandle = renderLayerDom(
            <BrushImage
                identity={identity}
                layer={layer}
                isNavigator={true}
                renderEnd={() => {
                    resolve(removeDomHandle);
                }}
            />,
        );
    });
}
